import { FORGOT_PASSWORD, LOGIN, REGISTER, RESET_PASSWORD, UPDATE_ACCOUNT, UPLOAD_IMAGE, VIEW_ACCOUNT } from "./types";


export const loginAction = (data, onSuccess, onError) => {
    return {
        type: LOGIN,
        data,
        onSuccess,
        onError,
    };
};

export const registerAction = (data, onSuccess, onError) => {
    return {
        type: REGISTER,
        data,
        onSuccess,
        onError,
    };
};

export const accountDetailsAction = (data, onSuccess, onError) => {
    return {
        type: VIEW_ACCOUNT,
        data,
        onSuccess,
        onError,
    };
};

export const accountUpdateAction = (data, onSuccess, onError) => {
    return {
        type: UPDATE_ACCOUNT,
        data,
        onSuccess,
        onError,
    };
};

export const uploadImageAction = (file, onSuccess, onError) => {
    return {
        type: UPLOAD_IMAGE,
        file,
        onSuccess,
        onError,
    };
};

export const forgotPasswordAction = (data, onSuccess, onError) => {
    return {
        type: FORGOT_PASSWORD,
        data,
        onSuccess,
        onError,
    };
};

export const resetPasswordAction = (data, onSuccess, onError) => {
    return {
        type: RESET_PASSWORD,
        data,
        onSuccess,
        onError,
    };
};